import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

const Login              = lazy(() => import('../pages/auth/Login'));
const Register           = lazy(() => import('../pages/auth/Register'));
const RegisterOTP        = lazy(() => import('../pages/auth/RegisterOTP'));
const ForgotPassword     = lazy(() => import('../pages/auth/ForgotPassword'));
const ForgotPasswordOTP  = lazy(() => import('../pages/auth/ForgotPasswordOTP'));
const ResetPassword      = lazy(() => import('../pages/auth/ResetPassword'));
const ActiveAccountPage  = lazy(() => import('../pages/auth/ActiveAccountPage'));
const Error401           = lazy(() => import('../pages/error/Error401'));

const Fallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

function AuthRoutes() {
  return (
    <>
      <Suspense fallback={<Fallback />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/forgot-password-otp" element={<ForgotPasswordOTP />} />
          <Route path="/register-otp" element={<RegisterOTP />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/active-account" element={<ActiveAccountPage />} />
          <Route path="/error/401" element={<Error401 />} />
        </Routes>
      </Suspense>
      <ToastContainer />
    </>
  );
}

export default AuthRoutes;
